export default __webpack_public_path__ + "static/media/excelencia.f1a60fa1.svg";